export default function ConnectionsTab() {
    return (
        <h2>Connections</h2>
    );
}